// extracted by mini-css-extract-plugin
export default {"wrapper":"_404_wrapper__s+4bU","error":"_404_error__R7bsN"};